import { useAuth0 } from '../services/auth';
export default useAuth0;
